















import Vue from 'vue';

import { Loading, Icon, Tooltip } from '@descomplica/vue-components';
import Analytics from '@/helpers/analytics';
import VIEWS_NAMES from '@/router/viewsNames';
import accountsIframe from './helpers/accountsIframe';
import { showEqualWebDrawer } from './helpers/accessibility';

export default Vue.extend({
  components: { Loading, Icon, Tooltip },
  data() {
    return { isLoading: false };
  },
  async created() {
    const isAuthenticated = Boolean(this.$cookies.get('admissions-auth-token'));
    this.isLoading = true;

    await new Promise((res: any) => {
      setTimeout(() => res(), 400);
    });

    const tokenD = accountsIframe.getTokenD();

    if (!isAuthenticated) {
      if (tokenD) {
        const email = accountsIframe.getEmailByPocket();
        try {
          await this.$store.dispatch('GET_USER', { email });

          const { user } = this.$store.getters;
          if (user) {
            await this.$store.dispatch('CREATE_AUTH_TOKEN');
          }
        } catch {
          this.navigateToSignUp();
          return;
        } finally {
          this.isLoading = false;
        }
      }
    }

    try {
      await this.$store.dispatch('PULL_CURRENT_ADMISSION');
      await this.$store.dispatch('PULL_PIPELINE');
      await this.$store.dispatch('START_PIPELINE');
    } catch {
      // suppress error
    } finally {
      const { email, name } = this.$store.getters.user;
      Analytics.identify({ id: email, email, name });

      this.isLoading = false;
    }

    this.insertEqualWebScript();
  },
  methods: {
    insertEqualWebScript(): void {
      (window as any).interdeal = {
        sitekey: 'aecf6ffe12fa1c1d26fe0ed3b1d39c4a',
        Position: 'Right',
        Menulang: 'PT',
        domains: {
          js: 'https://cdn.equalweb.com/',
          acc: 'https://access.equalweb.com/',
        },
        btnStyle: {
          vPosition: [null, '20%'],
          color: {
            main: '#2E850F',
            second: '#000000',
          },
          scale: [0.5],
          icon: {
            type: 1,
            shape: 'circle',
            outline: false,
          },
        },
      };

      const scriptElement = document.createElement('script');
      scriptElement.src = 'https://cdn.equalweb.com/core/4.4.1/accessibility.js';
      scriptElement.defer = true;
      scriptElement.integrity =
        'sha512-tq2wb4PBHqpUqBTfTG32Sl7oexERId9xGHX2O3yF91IYLII2OwM1gJVBXGbEPaLmfSQrIE+uAOzNOuEUZHHM+g==';
      scriptElement.crossOrigin = 'anonymous';
      scriptElement.setAttribute('data-cfasync', 'true');

      document.body.appendChild(scriptElement);
    },
    navigateToSignUp() {
      this.$router.push({ name: VIEWS_NAMES.SIGN_UP });
    },

    navigateToSignIn() {
      this.$router.push({ name: VIEWS_NAMES.SIGN_IN });
    },
    showAccessibilityDrawer() {
      Analytics.track('Open accessibility drawer', {
        origin: 'Botão Acessibilidade',
      });

      showEqualWebDrawer();
    },
  },
});
